<ng-template #disclaimer bsModal class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="LatestUpdate" aria-hidden="true">
    <div class="modal-header">
        <h4 class="modal-title pull-left">{{businessFunction?.displayName}} - Terms of use</h4>
    </div>
    <div class="modal-body" style="max-height: 15rem; overflow-y:scroll">
        <div class="row row--content user-content">
            @if (businessFunction) {
            <div class="col">
                <p class="text-red">Please accept our terms of use below before continuing.</p>
                <p [innerHTML]="businessFunction.disclaimers"></p>
            </div>
            }
        </div>
    </div>

    <div class="modal-footer">
        <div class="row w-100 no-gutters align-items-center">
            <div class="col-6 text-left">
                <input type="checkbox" value="true" [(ngModel)]="disclaimerAccepted" class="mr-1 mt-0" />
                <small class="textBody--sm">
                    <strong>I accept</strong> the above terms of use
                </small>
            </div>
            <div class="col-6 text-right">
                @if (disclaimerAccepted) {
                <button type="button" class="btn btn-info btn-sm btn-inline-block" (click)="onAcceptedClicked()">
                    Continue <i class="fa fa-arrow-circle-r- ml-1"></i>
                </button>
                }
            </div>
        </div>
    </div>
</ng-template>